class GravityForm {
  submit_text = '';
  button =  $('.gform_wrapper .button');
  
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    let _t = this;
    _t.button.on('click', function() {
      _t.submit_text = $(this).val();
      $(this).val('Please wait...')
    });

    $(document).on("gform_confirmation_loaded", (e, form_id) => _t.button.val(_t.submit_text));
  }

}

$(() => new GravityForm())